<template>
    <div class="mainContent">
        <!-- 頁首 -->
        <Header :title="title" :isBack="true" />

        <!-- 簡述 -->
        <b-container>
            <!-- 標題 -->
            <PwaTitle :textTitle="station.title" :showMore="false"></PwaTitle>
            <div class="global-descript" style="padding-bottom: 20px;">{{ station.descript }}</div>

            <button class="global-button w3-button w3-round w3-block w3-brown" @click="goPwaWeatherStationYunlinMap()"><i aria-hidden="true" class="fa fa-map"></i> 前往圖台檢視感測器資料 </button><br />
            <button class="global-button w3-button w3-round w3-block w3-deep-purple" @click="addStation()"><i aria-hidden="true" class="fa fa-plus"></i> 新增微氣候感測器資料 </button>
        </b-container>

        <!-- 測站資訊 -->
        <b-container
        v-show="station.list_choose.length > 0"
        v-for="(value, key) in station.list_choose"
        :key="'type' + key"
        >
            <div style="display:flex; justify-content:space-between;">
                <PwaTitle
                :textTitle="(key + 1) + '.即時感測站-' + value.code"
                :showMore="false">
                </PwaTitle>
                <h2 class="global-title" @click="cancel(value.id)">
                <i class="fa fa-close w3-xlarge"></i>
                </h2>
            </div> 

            <p class="global-descript" style="text-align:start;" v-if="value.sitesec_number != '無'">
            {{ value.town + ' ' + value.sitesec_name + ' ' + value.sitesec_number }}
            </p>
            <p class="global-descript" style="text-align:start;" v-else>
            {{ value.town + ' ' + value.sitesec_name }}
            </p>

            <p class="global-descript" style="text-align:end;">
            感測時間: {{ value.time.replace("T", " ").split(".")[0] }}
            </p>

            <!-- 溫度 -->
            <div class="w3-col w3-margin-bottom" style="width:33.33%">
                <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                    <li class="global-descript">{{ station.field.temperature }}</li>
                    <li class="global-descript">
                    <b>{{ formatValue(value.temperature) }} {{ station.unit.temperature }}</b>
                    </li>
                </ul>
            </div>

            <!-- 雨量 -->
            <div class="w3-col w3-margin-bottom" style="width:33.33%">
                <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                    <li class="global-descript">{{ station.field.rainfall }}</li>
                    <li class="global-descript">
                    <b>{{ formatValue(value.rainfall) }} {{ station.unit.rainfall }}</b>
                    </li>
                </ul>
            </div>

            <!-- 相對溼度 -->
            <div class="w3-col w3-margin-bottom" style="width:33.33%">
                <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                    <li class="global-descript">{{ station.field.relative_humidity }}</li>
                    <li class="global-descript">
                    <b>{{ formatValue(value.relative_humidity) }} {{ station.unit.relative_humidity }}</b>
                    </li>
                </ul>
            </div>

            <!-- 風速 -->
            <div class="w3-col w3-margin-bottom" style="width:33.33%">
                <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                    <li class="global-descript">{{ station.field.wind_speed }}</li>
                    <li class="global-descript">
                    <b>{{ formatValue(value.wind_speed) }} {{ station.unit.wind_speed }}</b>
                    </li>
                </ul>
            </div>

            <!-- 風向 -->
            <div class="w3-col w3-margin-bottom" style="width:33.33%">
                <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                    <li class="global-descript">{{ station.field.wind_direction }}</li>
                    <li class="global-descript">
                    <b>{{ formatValue(value.wind_direction) }} {{ station.unit.wind_direction }}</b>
                    </li>
                </ul>
            </div>

            <!-- 日射量 -->
            <div class="w3-col w3-margin-bottom" style="width:33.33%">
                <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                    <li class="global-descript">{{ station.field.solar_irradiance }}</li>
                    <li class="global-descript">
                    <b>{{ formatValue(value.solar_irradiance) }} {{ station.unit.solar_irradiance }}</b>
                    </li>
                </ul>
            </div>

            <div>&nbsp;</div>
        </b-container>

        <b-container v-show="station.list_choose.length == 0" >
            <!-- 標題 -->
            <PwaTitle :textTitle="'您目前尚未新增微氣候感測器'" :showMore="false"></PwaTitle>
            <p class="global-descript">請點選新增微氣候感測器資料後，並選擇鄉鎮市區、地段、地號，於清單選項中右上方"十"按鈕新增。</p>
        </b-container>
        <!-- 彈出視窗(智慧農業成果) -->
        <ModalWindow 
            :show="modal.add.show"
            :textTitle="modal.add.title" 
            :maxWidth="'450px'"
            @ClickClose="modal.add.show = false;">
            <div style="min-height: 600px;max-height: 600px; overflow-y: auto;">
                
                <div class="w3-row">
                    <!-- 鄉鎮市區 -->
                    <div class="w3-col w3-container m4 l4">
                        <p>
                            <label class="global-descript">{{ modal.add.input.town.text }}</label>
                            <v-select class="global-descript" v-model="modal.add.input.town.value" :options="modal.add.input.town.list" :reduce="(option) => option.value" label="text"></v-select>
                        </p>
                    </div>
                    
                    <!-- 地段 -->
                    <div class="w3-col w3-container m4 l4">
                        <p>
                            <label class="global-descript">{{ modal.add.input.sitesec_name.text }}</label>
                            <v-select class="global-descript" v-model="modal.add.input.sitesec_name.value" :options="modal.add.input.sitesec_name.list" :reduce="(option) => option.value" label="text"></v-select>
                        </p>
                    </div>

                    <!-- 地號 -->
                    <div class="w3-col w3-container m4 l4">
                        <p>
                            <label class="global-descript">{{ modal.add.input.sitesec_number.text }}</label>
                            <v-select class="global-descript" v-model="modal.add.input.sitesec_number.value" :options="modal.add.input.sitesec_number.list" :reduce="(option) => option.value" label="text"></v-select>
                        </p>
                    </div>

                </div>

                <!-- 測站資訊 -->
                <b-container
                style="padding-right: 5px;padding-left: 5px;"
                v-for="(value, key) in modal.add.list"
                :key="'type' + key"
                >

                    <div style="display:flex; justify-content:space-between;">
                        <PwaTitle
                        :textTitle="(key + 1) + '.即時感測站-' + value.code"
                        :showMore="false">
                        </PwaTitle>
                        <h2 class="global-title" @click="choose(value.id)">
                        <i class="fa fa-plus w3-xlarge"></i>
                        </h2>
                    </div> 

                    <p class="global-descript" style="text-align:start;" v-if="value.sitesec_number != '無'">
                    {{ value.town + ' ' + value.sitesec_name + ' ' + value.sitesec_number }}
                    </p>
                    <p class="global-descript" style="text-align:start;" v-else>
                    {{ value.town + ' ' + value.sitesec_name }}
                    </p>

                    <p class="global-descript" style="text-align:end;">
                    感測時間: {{ value.time.replace("T", " ").split(".")[0] }}
                    </p>

                    <!-- 溫度 -->
                    <div class="w3-col w3-margin-bottom" style="width:33.33%">
                        <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                            <li class="global-descript">{{ station.field.temperature }}</li>
                            <li class="global-descript">
                            <b>{{ formatValue(value.temperature) }} {{ station.unit.temperature }}</b>
                            </li>
                        </ul>
                    </div>

                    <!-- 雨量 -->
                    <div class="w3-col w3-margin-bottom" style="width:33.33%">
                        <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                            <li class="global-descript">{{ station.field.rainfall }}</li>
                            <li class="global-descript">
                            <b>{{ formatValue(value.rainfall) }} {{ station.unit.rainfall }}</b>
                            </li>
                        </ul>
                    </div>

                    <!-- 相對溼度 -->
                    <div class="w3-col w3-margin-bottom" style="width:33.33%">
                        <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                            <li class="global-descript">{{ station.field.relative_humidity }}</li>
                            <li class="global-descript">
                            <b>{{ formatValue(value.relative_humidity) }} {{ station.unit.relative_humidity }}</b>
                            </li>
                        </ul>
                    </div>

                    <!-- 風速 -->
                    <div class="w3-col w3-margin-bottom" style="width:33.33%">
                        <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                            <li class="global-descript">{{ station.field.wind_speed }}</li>
                            <li class="global-descript">
                            <b>{{ formatValue(value.wind_speed) }} {{ station.unit.wind_speed }}</b>
                            </li>
                        </ul>
                    </div>

                    <!-- 風向 -->
                    <div class="w3-col w3-margin-bottom" style="width:33.33%">
                        <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                            <li class="global-descript">{{ station.field.wind_direction }}</li>
                            <li class="global-descript">
                            <b>{{ formatValue(value.wind_direction) }} {{ station.unit.wind_direction }}</b>
                            </li>
                        </ul>
                    </div>

                    <!-- 日射量 -->
                    <div class="w3-col w3-margin-bottom" style="width:33.33%">
                        <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                            <li class="global-descript">{{ station.field.solar_irradiance }}</li>
                            <li class="global-descript">
                            <b>{{ formatValue(value.solar_irradiance) }} {{ station.unit.solar_irradiance }}</b>
                            </li>
                        </ul>
                    </div>

                    <div>&nbsp;</div>
                </b-container>


            </div> 
        </ModalWindow>

    </div>
</template>
<script>
import Header from '@/components/pwa/Header.vue'
import PwaTitle from '@/components/pwa/PwaTitle.vue'
import ModalWindow from '@/components/pwa/ModalWindow.vue'
export default {
    created() {
        window.vue = this;
        if(!window.checkLogin()){ window.setPage("login");}               
    },  
    components: {
        Header,
        PwaTitle,
        ModalWindow
    },
    data(){
        return {
            title: "雲林微氣候觀測站",

            //雲林微氣候觀測站說明
            station:{
                title:"微氣候感測器資料整合",
                descript:"本專區即時介接中央氣象局觀測資料，提供雲林縣各鄉鎮之溫度、降雨量、風速風向、日照時數等氣象資訊，使用者可快速掌握各地即時天氣與未來幾日的氣象預報，以利農事安排與防災規劃。",
                
                field:{
                    //鄉鎮市區
                    town:"鄉鎮市區",
                    //地段
                    sitesec_name:"地段",
                    //地號
                    sitesec_number:"地號",
                    //溫度
                    temperature:"溫度",
                    //雨量
                    rainfall:"雨量",
                    //相對濕度
                    relative_humidity:"相對濕度",
                    //風速
                    wind_speed:"風速",
                    //風向
                    wind_direction:"風向",
                    //日射量
                    solar_irradiance:"日射量",
                },
                unit:{
                    //鄉鎮市區
                    town:"",
                    //地段
                    sitesec_name:"",
                    //地號
                    sitesec_number:"",
                    //溫度
                    temperature:"°C",
                    //雨量
                    //rainfall:"mm/hr",
                    rainfall:"mm",
                    //相對濕度
                    relative_humidity:"%",
                    //風速
                    wind_speed:"mm",
                    //風向
                    wind_direction:"",
                    //日射量
                    solar_irradiance:"W/m²",
                },
                /*
                list:[
                    {
                        //名稱
                        name:"易圖開發測試(古坑鄉)",
                        //代碼
                        code:"01",
                        //時間
                        time:"",

                        //鄉鎮市區
                        town:"古坑鄉",
                        //地段
                        sitesec_name:"永昌段",
                        //地號
                        sitesec_number:"78-2",
                        //溫度
                        temperature:"24.3",
                        //雨量
                        rainfall:"0.0",
                        //相對濕度
                        relative_humidity:"80",
                        //風速
                        wind_speed:"5.5",
                        //風向
                        wind_direction:"北北東",
                        //日射量
                        solar_irradiance:"0.01",
                    },
                    
                ],
                */
                list:[],
                list_choose:[],
            },

            //彈出視窗
            modal:{   
                
                //新增
                add:{

                    //是否呈現
                    show:false,
                    title:"新增微氣候感測器資料",
                    list:[],
                    //表單物件
                    input:{
                        //鄉鎮市區
                        town:{
                            text:"鄉鎮市區",
                            value:"",
                            placeholder:"請選擇鄉鎮市區",
                            list:[]
                        },
                        //地段
                        sitesec_name:{
                            text:"地段",
                            value:"",
                            placeholder:"請選擇地段",
                            list:[]
                        },
                        //地號
                        sitesec_number:{
                            text:"地號",
                            value:"",
                            placeholder:"請選擇地號",
                            list:[]
                        },
                    }, 
                },
            },

            //農業氣象觀測-取得縣市清單
            apiCurlFacturer: (data) => this.userRequest.get("API/Default/CurlFacturerSelect", data),
        }
    },
    mounted() {

        //農業氣象觀測-取得縣市清單
        this.getCurlFacturer({}); 
    },
    methods: {

        formatValue(val) {
            // null / undefined
            if (val === null || val === undefined) return '\u00A0';

            // 轉成字串後處理
            const str = val.toString().trim();
            return str === '' ? '\u00A0' : str;
        },

        //啟用遮罩
        enableDefaultLoad:function()
        {
            this.enableMask();
            this.default_load = true;
        },

        //取消遮罩
        disableDefaultLoad:function()
        {
            //暫時先設定延遲，否則watch會重複觸發
            const _this = this;
            window.ThreadTool.Delay(function(){

                _this.disableMask();
                _this.default_load = false;

            },this.delay_ms_api);
        },

        //智慧農業成果(圖片)(已選擇)
        addStation() {

            if(this.station.list.length == 0)
            {
                alert("目前已無其他感測器可選");
                return false;
            }
            else
            {
                this.modal.add.input.town.value = "";
                this.modal.add.input.town.list = [];

                var town = [...new Set(this.station.list.map(item => item.town))];
                this.modal.add.input.town.list = town.map(town => ({
                    text: town,
                    value: town
                }));

                this.modal.add.show = true;
            }
        },
        //選擇
        choose(id) {
 
            const index = this.station.list.findIndex(item => item.id === id);

            if (index > -1) {
                const [obj] = this.station.list.splice(index, 1); // 從 A 移除
                this.station.list_choose.push(obj); // 加入 B
            }

            this.modal.add.list = [];
            var list = this.station.list.filter(item => item.town === this.modal.add.input.town.value && item.sitesec_name === this.modal.add.input.sitesec_name.value && item.sitesec_number === this.modal.add.input.sitesec_number.value);
            this.modal.add.list = list;

            //表示目前篩選結果已經沒資料了
            if(this.modal.add.list.length == 0)
            {
                //表示現在已經全部選完了(沒資料可以選了)
                if(this.station.list.length == 0)
                {
                    alert("您已將所有感測器全選完了。");
                    this.modal.add.input.town.value = "";
                    this.modal.add.input.sitesec_name.value = "";
                    this.modal.add.input.sitesec_number.value = "";
                    this.modal.add.input.town.list = [];
                    this.modal.add.input.sitesec_name.list = [];
                    this.modal.add.input.sitesec_number.list = [];
                    this.modal.add.show = false;
                }
                else
                {
                    this.modal.add.input.town.value = "";
                    this.modal.add.input.sitesec_name.value = "";
                    this.modal.add.input.sitesec_number.value = "";
                    this.modal.add.input.town.list = [];
                    this.modal.add.input.sitesec_name.list = [];
                    this.modal.add.input.sitesec_number.list = [];

                    var town = [...new Set(this.station.list.map(item => item.town))];
                    this.modal.add.input.town.list = town.map(town => ({
                        text: town,
                        value: town
                    }));
                }
            }
        },
        //取消
        cancel(id) {

            const index = this.station.list_choose.findIndex(item => item.id === id);

            if (index > -1) {
                const [obj] = this.station.list_choose.splice(index, 1); // 從 A 移除
                this.station.list.push(obj); // 加入 B
            }
        },

        //取得中央氣象屬(鄉鎮市區及作物)
        getCurlFacturer(data) {
            this.enableDefaultLoad();
            this.apiCurlFacturer(data)
                .then((res) => {

                    var list = JSON.parse(res.data);
                    this.disableDefaultLoad();
                    this.station.list = [];
                    for(var i=0 ; i<list.length ; i++)
                    {
                        var item = list[i];
                        this.station.list.push({

                            //識別碼
                            id:item.ID,
                            //名稱
                            name:item.Name,
                            //代碼
                            code:item.Code,
                            //時間
                            time:item.CreateTime,
                            //鄉鎮市區
                            town:item.Town,
                            //地段
                            sitesec_name:item.SitesecName,
                            //地號
                            sitesec_number:item.SitesecNumber,
                            //溫度
                            temperature:item.TemperatureValue,
                            //雨量
                            rainfall:item.RainfallValue,
                            //相對濕度
                            relative_humidity:item.RelativeHumidityValue,
                            //風速
                            wind_speed:item.WindSpeedValue,
                            //風向
                            wind_direction:item.WindDirectionValue,
                            //日射量
                            solar_irradiance:item.SolarIrradianceValue,
                        });

                    }

                })
                .catch((err) => {
                    this.disableDefaultLoad();
                    console.log(err);
                });
        },

        //前往 農業情報站
        goPwaWeatherStationYunlinMap() { window.location = "pwa.html#/PwaWeatherStationYunlinMap"; },
    },
    watch: {

        //新增微氣候感測器資料-鄉鎮市區
        "modal.add.input.town.value":function(val)
        {
            this.modal.add.input.sitesec_name.value = "";
            this.modal.add.input.sitesec_number.value = "";
            this.modal.add.input.sitesec_name.list = [];
            this.modal.add.input.sitesec_number.list = [];

            if(val != "")
            {
                // 先篩出選定的 Town
                var sitesec_name = this.station.list.filter(item => item.town === this.modal.add.input.town.value);
                // 取出不重複的 SitesecName
                sitesec_name = [...new Set(sitesec_name.map(item => item.sitesec_name))];
                // 若要轉成 Vue 選單用的格式
                sitesec_name = sitesec_name.map(name => ({
                    text: name,
                    value: name
                }));
                console.log(sitesec_name);
                this.modal.add.input.sitesec_name.list = sitesec_name;
            }

            
        },

        //新增微氣候感測器資料-地段
        "modal.add.input.sitesec_name.value":function(val)
        {
            this.modal.add.input.sitesec_number.value = "";
            this.modal.add.input.sitesec_number.list = [];

            if(val != "")
            {
                // 先篩出選定的 Town
                var sitesec_number = this.station.list.filter(item => item.town === this.modal.add.input.town.value && item.sitesec_name === this.modal.add.input.sitesec_name.value);
                // 取出不重複的 SitesecName
                sitesec_number = [...new Set(sitesec_number.map(item => item.sitesec_number))];
                // 若要轉成 Vue 選單用的格式
                sitesec_number = sitesec_number.map(name => ({
                    text: name,
                    value: name
                }));
                this.modal.add.input.sitesec_number.list = sitesec_number;
            }            
        },

        //新增微氣候感測器資料-地號
        "modal.add.input.sitesec_number.value":function(val)
        {
            this.modal.add.list = [];

            if(val != "")
            {
                // 先篩出選定的 Town
                var list = this.station.list.filter(item => item.town === this.modal.add.input.town.value && item.sitesec_name === this.modal.add.input.sitesec_name.value && item.sitesec_number === this.modal.add.input.sitesec_number.value);
                this.modal.add.list = list;
            }
            
        },

    }
}
</script>
<style scoped>

</style>